module.exports = __webpack_public_path__ + "static/img/mpdpBottom3.1096720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpdpBottom3.png
// module id = UX2k
// module chunks = 2